import Base from "./Base.js";

import { search } from "api/graphql/queries.js";
export default class ProxyAPI extends Base {
  async search(payload, stream, options) {
    if (stream && process.env.REACT_APP_SEARCH_RESOLVER_STREAM_URL) {
      const res = await this.apiClient.postStreamAndDecompress(
        process.env.REACT_APP_SEARCH_RESOLVER_STREAM_URL,
        { ...payload },
        options
      );

      if (!res) {
        return;
      }

      if (res.error) {
        console.error(res.error);

        return;
      }

      return res;
    }

    const res = await this.apiClient.request({
      query: search,
      payload,
    });

    return JSON.parse(res.data.search);
  }
}
